import { Add, Edit, Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { EPrefFrequencyDialog } from "./EPrefFrequencyDialog";
import { EPrefItemDto } from "./types";

export function EPrefFrequencyListPage() {
    const [useStore] = useState(() => createListStore<EPrefItemDto>({
        path: "settings/ePrefFrequency",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "name", label: "Name", width: 200 },
            { column: "code", label: "Code", width: 200 },
            { column: "isActive", label: "Active", width: 120, type: "bool" },
            { column: "priority", label: "Priority", width: 120 },
        ],
    }));

    const ePreferencesItems = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteItem() {
        await simpleDialog.show("Email preference frequency", "Delete email preference frequency?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/ePrefFrequency/${ePreferencesItems?.selectedItem?.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <EPrefFrequencyDialog close={close} ePrefItem={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const editDialog = useDialog(close => <EPrefFrequencyDialog close={close} ePrefItem={ePreferencesItems.selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Email preference frequency types" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={ePreferencesItems.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={ePreferencesItems.selectedItem == null} title="Delete" onClick={deleteItem}><Delete /></Button>],
            ]),
        })}
    </>;
}
